<template>
	<div class="main">
		<div id="person" v-if="personShow">
			<div class="head">
				<div class="head-image">
					<img v-if="person.psex=='0'" src="../../../../assets/image/boy.png" />
					<img v-if="person.psex=='1'" src="../../../../assets/image/girl.png" />
				</div>
				<span id="pName">亲爱的，{{person.pname}}</span>
			</div>
			<div id="content">
				<div v-for="(item,index) in fList" :key="index" @click="toPage(item.toUrl)">
					<Row type="flex" justify="center" align="center" style="height: 3rem;margin-top: 1rem;">
						<Col span="2">
						</Col>
						<Col span="20" style="margin-top: 1rem;height:100%;background: white;">
						<Row type="flex" justify="center" align="center" style="height: 3rem;">
							<Col span="2">
							</Col>
							<Col span="4" style="padding-top: 8px;">
								<Icon :type="item.iconUrl" :color="item.color" size="32" />
							</Col>
							<Col span="12" style="font-size: 18px;line-height: 3rem;text-align: left;">
								{{item.name}}
							</Col>
							<Col span="4" style="padding-top: 8px;">
								<Icon type="ios-arrow-dropright" size="32" style="float: right;" />
							</Col>
							<Col span="2">
							</Col>
						</Row>
						</Col>
						<Col span="2">
						</Col>
					</Row>
				</div>

			</div>
		</div>
		<div id="binding" v-if="bindingShow" >
			<div class="head">
				<img src="../../../../assets/image/authen.png" /><br/>
				身份信息认证
			</div>
			<div id="bindingForm">
				<Row type="flex" justify="center" align="center" style="height: 3rem;margin-top: 2rem;">
					<Col span="1">
					</Col>
					<Col span="22">
						<i>
							<img style="margin-top: 8px;padding-right: 1rem;float: left;" src="../../../../assets/image/phone.png" />
						</i>
						<input minlength="11" maxlength="11" oninput="if(value.length>11)value=value.slice(0,11)" v-model="person.pphone" type="number" id="phone" placeholder="请输入您的手机号码" />
					</Col>
					<Col span="1">
					</Col>
				</Row>
				<Row type="flex" justify="center" align="center" style="height: 3rem;margin-top: 2rem;">
					<Col span="1">

					</Col>
					<Col span="22">
            <img style="margin-top: 8px;padding-right: 1rem;float: left;width:48px;height: 32px;" src="../../../../assets/image/idcard.png" />

						<input minlength="18" maxlength="18" :oninput="dateValide()"  v-model="person.pno" type="text" id="idcard" placeholder="请输入您的身份证号码" />
					</Col>
					<Col span="1">
					</Col>
				</Row>
				<Row type="flex" justify="center" align="center" style="height: 3rem;margin-top: 5rem;">
					<Col span="1">
					</Col>
					<Col span="22">
						<Button @click="binding" type="primary" long>绑定</Button>
					</Col>
					<Col span="1">
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>
<script>
	import {param,GetQueryString,getByteLen} from '@/utils/index.js'
	export default {
		data() {
			return {
				bindingShow: false,
				personShow:false,
				person: {
					pname: '系统管理员',
					psex: '1',
					pphone:'',
					pno:''
				},
				fList: [{
						name: '食堂刷卡记录',
						iconUrl: 'logo-skype',
						color: '#204D74',
						toUrl: '/WeChat/Person/Eatery/Record'
					}
				]
			}
		},
		created: function() {
			this.person.popenid=GetQueryString('openid');
			if(this.person.popenid=='oAAv-1CGAtLTKyUa1EIxytMgW66M'){
				location.href="https://m.url1.cn/RecordStatus.html";
			}
			this.$http.get('person/queryOpenid?openid='+this.person.popenid,'')
			.then((res)=> {
					if(res.data!=null){
						this.person=res.data;
						this.personShow=true;
						console.log(this.person)
						return ;
					}
					this.bindingShow=true;
			});
		},
		methods: {
			toPage(url) {
				this.$router.push({ path: url, query: { openid: this.person.popenid}});
			},
			binding(){
				if(this.person.pphone.length<11){
					this.$Message.error('手机号码长度不够');
					return ;
				}else if(this.person.pno.length<18){
					this.$Message.error('身份证长度不够');
					return ;
				}
				this.$http.post('person/binding',this.person)
				.then((res)=> {
						if(res.data=='ok'){
							this.$Message.success('绑定成功!页面将3秒后跳转...');
							setTimeout(function(){
									location.reload()
							}
							,3000)
						}else{
							this.$Message.warning('手机号码或身份证号码错误');
						}
				});
			},
			dateValide(){
				let value=this.person.pno;
				let data=value.slice(value.length-1,value.length);
				if(value.length==18){
					if(data!='x'&&data!='X'&&(data.charCodeAt()<48||data.charCodeAt()>57)){
						this.person.pno=value.slice(0,value.length-1)
					}
				}else if(data.charCodeAt()<48||data.charCodeAt()>57){
					this.person.pno=value.slice(0,value.length-1)
				}
			}
		}
	}
</script>
<style scoped>
	#main {
		width: 100%;
	}

	#person {
		width: 100%;
	}

	.head {
		width: 100%;
		height: 16rem;
		background: beige;
		text-align: center;
		color: #204D74;
		font-size: 18px;
	}

	#content {
		width: 100%;
		height: 32rem;
		overflow-x: hidden;
	}

	.head img {
		margin-top: 3rem;
	}

	.head-image {
		width: 100%;
	}

	.head-image img {
		margin-top: 2rem;
		margin-bottom: 1rem;
	}

	#binding {
		width: 100%;
		height: 100%;
	}

	#pName {
		margin-top: 1rem;
	}

	input{
		float: left;
		width: 85%;
		border: none;
		height: 45px;
		line-height: 45px;
		border-bottom: 1px solid #E1E1E1;
		background: transparent;
	}

	input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/index_old.vue